import React, { } from 'react';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone')
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

export default function ObjectOwnerDescription(props) {
    const { object: instance, extend, inline, style, className } = props;
    // useEffect(() => {

    // }, [item])
    return (
        <div className={className} style={style}>
            {instance &&
                <div>
                    {!inline && <div style={{ display: "flex", flexDirection: "column" }}>
                        {instance?.meropriyatie && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                            <span>{instance?.meropriyatie?.nazvanieMeropriyatiya}</span> - {dayjs(instance?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} {(instance?.meropriyatie?.mestoProvedeniya) ? "(" + instance?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}
                        </div>}
                        {instance?.organizatorFederatsiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                            <span>Федерация</span>
                        </div>}
                        {instance?.organizatorRegionalnoeOtdelenieID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                            <span>{instance?.organizatorRegionalnoeOtdelenie?.nazvanie}</span>
                        </div>}
                        {instance?.organizatorShkolaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                            <span>{instance?.organizatorShkola?.nazvanieShkoliTantsev}</span>
                        </div>}
                        {instance?.organizatorMeropriyatiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                            <span>{instance?.organizatorMeropriyatiya?.nazvanie}</span>
                        </div>}
                    </div>}
                    {!!inline && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                        {instance?.meropriyatie && <span>
                            {/* <span><i className="fa fa-circle" style={{ fontSize: "6px" }}></i></span> */}
                            <span>{instance?.meropriyatie?.nazvanieMeropriyatiya}</span> - {dayjs(instance?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} {(instance?.meropriyatie?.mestoProvedeniya) ? "(" + instance?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}
                        </span>}
                        {instance?.organizatorFederatsiyaID && <span>
                            {/* <span><i className="fa fa-circle" style={{ fontSize: "6px" }}></i></span> */}
                            <span>Федерация</span>
                        </span>}
                        {instance?.organizatorRegionalnoeOtdelenieID && <span>
                            {/* <span><i className="fa fa-circle" style={{ fontSize: "6px" }}></i></span> */}
                            <span>{instance?.organizatorRegionalnoeOtdelenie?.nazvanie}</span>
                        </span>}
                        {instance?.organizatorShkolaID && <span>
                            {/* <span><i className="fa fa-circle" style={{ fontSize: "6px" }}></i></span> */}
                            <span>{instance?.organizatorShkola?.nazvanieShkoliTantsev}</span>
                        </span>}
                        {instance?.organizatorMeropriyatiyaID && <span>
                            {/* <span><i className="fa fa-circle" style={{ fontSize: "6px" }}></i></span> */}
                            <span>{instance?.organizatorMeropriyatiya?.nazvanie}</span>
                        </span>}
                    </div>}
                </div>
            }
            {extend && extend()}
        </div>
    )
}
